import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=73fcd0d0&scoped=true"
import script from "./Empty.vue?vue&type=script&setup=true&lang=js"
export * from "./Empty.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Empty.vue?vue&type=style&index=0&id=73fcd0d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fcd0d0",
  null
  
)

export default component.exports